import * as React from "react";
const SvgFiRrMessageBot = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-message-bot_svg__a)">
      <path
        fill="#062147"
        d="M23 9h-1V4c0-2.206-1.794-4-4-4H6C3.794 0 2 1.794 2 4v5H1a1 1 0 1 0 0 2h1v5c0 2.206 1.794 4 4 4h.923l3.748 3.156c.382.34.862.509 1.338.509.467 0 .931-.163 1.292-.485L17.148 20H18c2.206 0 4-1.794 4-4v-5h1a1 1 0 1 0 0-2m-3 7c0 1.103-.897 2-2 2h-1.211c-.232 0-.458.081-.637.229l-4.172 3.415-4.047-3.409A1 1 0 0 0 7.289 18H6c-1.103 0-2-.897-2-2V4c0-1.103.897-2 2-2h12c1.103 0 2 .897 2 2zM16 6H8a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2m-6.5 6a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 9.5 12m5 0a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 14.5 12"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-message-bot_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrMessageBot;
